import UploadBook from './UploadBook'
import React from "react";
import './PageUploadBook.css'

const PageUloadBook = () => {
    return (
        <div className={"fondoImg"}>
            <UploadBook></UploadBook>
        </div>

    )
}

export default PageUloadBook;